import React, { Component } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import classes from "./ViewJobProfile.module.css";
import { connect } from "react-redux";
import * as actionTypes from "../../../Action/Index";

class ViewJobProfile extends Component {
  dateFormat = () => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    if (this.props.viewSingleData != undefined) {
      let current_datetime = new Date(this.props.viewSingleData.created / 1000);
      var formatted_date =
        current_datetime.getDate() + " " + months[current_datetime.getMonth()];
    }
    return formatted_date;
  };

  render() {
    return (
      <Modal
        dialogClassName={classes.createModal}
        {...this.props}
        size="lg"
        // backdrop = "false"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        //  onShow = {()=>console.log(this.props.viewSingleData)}
      >
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={classes.Title}
        >
          Profile
        </Modal.Title>
        <Modal.Body>
          <Form onSubmit={(e) => this.handleSubmit(e)}>
            <Form.Row className={classes.Row} style={{ marginTop: "0px" }}>
              <Form.Label
                column
                lg={4}
                md={3}
                sm={4}
                xs={6}
                className={classes.InputFont}
              >
              Title:
              </Form.Label>
              <Col style={{ paddingTop: "6px" }} lg={8} md={8} sm={6} xs={10}>
                <span>
                  {this.props.viewSingleData != undefined
                    ? this.props.viewSingleData.jobTitle
                    : ""}
                  {this.props.viewSingleData != undefined &&
                  this.props.viewSingleData.clientName != null &&
                  this.props.viewSingleData.clientName != ""
                    ? " (" + this.props.viewSingleData.clientName + ")"
                    : ""}
                </span>
                <span>
                  {this.props.viewSingleData != undefined
                    ? this.props.viewSingleData.name
                    : ""}
                </span>
                &nbsp;
                <span>
                  {/* {this.props.filterSchedule==true?
             <a href="JavaScript:Void(0);" onClick={() => { this.props.candidateDownloadFile(this.props.id) }} style = {{cursor: "pointer", float: 'right',fontWeight:"700",color:"#fbb03b"}}>View CV</a>  
            : */}
                  <a
                    target="_blank"
                    href={this.props.candidate_cv_data}
                    style={{
                      cursor: "pointer",
                      float: "right",
                      fontWeight: "700",
                      color: "#fbb03b",
                    }}
                  >
                    View Resume
                  </a>
                </span>
              </Col>
              {/* <Col style={{paddingTop:"6px"}} lg={8} md={8} sm={6} xs={10}>
                                    
            </Col> */}
            </Form.Row>
            <Form.Row className={classes.Row}>
              <Form.Label column lg={4} md={5} className={classes.InputFont}>
                Experience:
              </Form.Label>
              <Col style={{ paddingTop: "6px" }} lg={1} md={1}>
                <span>
                  {this.props.viewSingleData != undefined
                    ? this.props.viewSingleData.minExperience
                    : ""}{" "}
                  {this.props.viewSingleData != undefined
                    ? this.props.viewSingleData.minExperience <= 1
                      ? ""
                      : ""
                    : ""}
                </span>
              </Col>
              <Form.Label
                column
                lg={1}
                md={1}
                className={classes.InputFont}
                style={{
                  textAlign: "right",
                  marginLeft: "-20px",
                  marginRight: "10px",
                }}
              >
                {this.props.viewSingleData != undefined &&
                this.props.viewSingleData.minExperience <= 1
                  ? "Year"
                  : "Years"}
              </Form.Label>

              <Col style={{ paddingTop: "6px" }} lg={1} md={1}>
                <span>
                  &nbsp;
                  {this.props.viewSingleData != undefined
                    ? this.props.viewSingleData.maxExperience
                    : ""}{" "}
                  {this.props.viewSingleData != undefined
                    ? this.props.viewSingleData.maxExperience <= 1
                      ? ""
                      : ""
                    : ""}
                </span>
              </Col>
              <Form.Label
                column
                lg={1}
                md={6}
                className={classes.InputFont}
                style={{ textAlign: "right", marginLeft: "-20px" }}
              >
                {this.props.viewSingleData != undefined &&
                this.props.viewSingleData.maxExperience <= 1
                  ? "Month"
                  : "Months"}
              </Form.Label>
            </Form.Row>
            <Form.Row className={classes.Row}>
              <Form.Label
                column
                lg={4}
                md={3}
                sm={4}
                xs={6}
                className={classes.InputFont}
              >
                Date of Posting:
              </Form.Label>
              <Col style={{ paddingTop: "6px" }} lg={8} md={8} sm={6} xs={10}>
                <span>{this.dateFormat()}</span>
              </Col>
            </Form.Row>
            <Form.Row className={classes.Row}>
              <Form.Label className={classes.InputFont} column lg={4} md={7}>
                Skills:
              </Form.Label>
              <Col style={{ paddingTop: "6px" }} lg={8}>
                <span>
                  {this.props.viewSingleData !== undefined &&
                  this.props.viewSingleData !== null &&
                  this.props.viewSingleData.length != 0 ? (
                    <>
                      {this.props.viewSingleData.mustHaveJobSkills !==
                        undefined &&
                      this.props.viewSingleData.mustHaveJobSkills !== null
                        ? //     this.props.viewSingleData.mustHaveJobSkills.map((el,index)=>{
                          //         return index==this.props.viewSingleData.mustHaveJobSkills.length ? el.value: " "+el.value
                          //     })
                          //     :"")+
                          // (this.props.viewSingleData.mustHaveJobSkills!==undefined && this.props.viewSingleData.mustHaveJobSkills!==null?
                          //     (this.props.viewSingleData.mustHaveJobSkills.length==0?this.props.viewSingleData.otherMustHaveSkills.length!=0?[""]:[""]:this.props.viewSingleData.otherMustHaveSkills.length==0?[""]:[", "]):"")+
                          // (this.props.viewSingleData.otherMustHaveSkills!==undefined && this.props.viewSingleData.otherMustHaveSkills!==null?
                          //     this.props.viewSingleData.otherMustHaveSkills.map((el,index)=>{
                          //         return index==this.props.viewSingleData.otherMustHaveSkills.length ? el.value: " "+el.value
                          //     }):"")
                          // (this.props.viewSingleData.allJobSkillsWithPreecedence!==undefined &&  this.props.viewSingleData.allJobSkillsWithPreecedence!==null?

                          this.props.viewSingleData.allJobSkillsWithPreecedence.map(
                            (el, index) => {
                              return index ===
                                this.props.viewSingleData
                                  .allJobSkillsWithPreecedence.length -
                                  1
                                ? el.value.trim()
                                : el.value.trim() + ", ";
                              // return index==this.props.viewSingleData.allJobSkillsWithPreecedence.length ? el.value: this.props.viewSingleData.allJobSkillsWithPreecedence.length!=0?", "+el.value:""+el.value
                            }
                          )
                        : ""}
                    </>
                  ) : (
                    ""
                  )}
                </span>
              </Col>
            </Form.Row>
            {/* <Form.Row className={classes.Row} style={{ marginBottom: '40px' }}>
                            <Form.Label className={classes.InputFont} column lg={4} md={7}>
                                <span style={{marginBottom:"-10px"}}>Preferred skills :</span><br /><span style={{position:"relative",top:"-8px", fontSize: '12px',color: "grey"}}>(Optional)</span>
                            </Form.Label>
                            <Col style={{paddingTop:"6px"}} lg={8}>
                            <span>{this.props.viewSingleData!==undefined && this.props.viewSingleData.length!=0? 
                                  <>{
                                    (this.props.viewSingleData.preferredJobSkills!==undefined? this.props.viewSingleData.preferredJobSkills.map(el=>el.value+" "):"")+
                                    (this.props.viewSingleData.otherPreferredSkills!==undefined? this.props.viewSingleData.otherPreferredSkills.map(el=>el.value+" "):"")
                                 }</>:""}</span>
                            </Col>
                        </Form.Row>
                                 */}
            <Row>
              <Col style={{ marginLeft: "35%", marginTop: "30px" }}>
                <Button
                  onClick={() => this.props.hideJobProfileModal()}
                  variant="outline-primary"
                  className={classes.Button_1}
                >
                  OK
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loader: state.employeeReducer.loader,
    skillLoader: state.employeeReducer.skillLoader,
    skillList: state.employeeReducer.skillList,
    candidate_cv_data: state.employeeReducer.candidate_cv_data,
    // singleJobProfileDetails : state.employeeReducer.singleJobProfileDetails
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSkillsMaster: () => dispatch(actionTypes.getSkillsMaster()),
    candidateDownloadFile: (id) =>
      dispatch(actionTypes.candidateDownloadFile(id)),
    // viewSingleJobProfile:(id)=>dispatch(actionTypes.viewSingleJobProfile(id))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ViewJobProfile);
